import {
    StContentContainer,
    StListing,
    StListItem,
    StAlphabetListItem,
    StListText,
    StSubHeading,
    StHeading
} from './TermsAndConditionsTexts.styled';
import TermsAndConditionsParagraph from './TermsAndConditionsParagraph';

// ! markup is party autogenerated from docx files attaced in PORTAL-1682
export const TERMS_AND_CONDITIONS_ANZ_SCHOOL = (
    <StContentContainer>
        <StHeading>School Terms and Conditions</StHeading>
        <p className="P1">
            Welcome to BorrowBox,
            <a id="_GoBack" /> a Bolinda Digital service comprising the mobile services, apps, website and any software
            provided on or in connection with Bolinda Digital services (collectively the “Service”).
        </p>
        <p className="P1">
            These Terms and Conditions must be read in conjunction with the School Subscription Letter (together
            “Agreement”). By signing the School Subscription Letter you agree to be bound by these Terms and Conditions.
        </p>
        <p className="P1">
            Under this Agreement, Bolinda Digital Pty Ltd (“Bolinda Digital”) will:
            <StListing leftOffset>
                <StListItem>
                    provide your students, parents and staff (“End Users”) access to the Service under End User Terms
                    and Conditions (“EUTC”), which End Users must accept in order to borrow electronic media including
                    but not limited to audio books and ebooks (“Content”); and
                </StListItem>
                <StListItem>
                    provide you with a system (“Back Office System”) to manage the provision of the Service to your End
                    Users.
                </StListItem>
            </StListing>
        </p>
        <p className="P1">
            <StSubHeading>1. Usage of Back Office System</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="1.1">
                Subject to the terms of this Agreement, Bolinda Digital grants you a non- exclusive, non-transferable
                licence to use the Back Office System, the Service, and the Content for the sole purpose of providing
                End Users with access to the Service so that they can borrow Content.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="1.2">
                You must not:
                <StListing type="a">
                    <StAlphabetListItem>
                        <StListText>
                            except as expressly permitted under this Agreement, license, sub- license, sell, transfer,
                            assign, distribute or otherwise commercially exploit or make available to any third party
                            the Back Office System, Service or Content in any way;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            modify or make derivative works based upon the Back Office System, Service or Content; or
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            reverse engineer or access the Back Office System or Service in order to build a competitive
                            product or service or a product with similar ideas, features, functions or graphics as the
                            Back Office System or Service.
                        </StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="1.3">
                You must not allow Back Office System user licences to be shared or used by more than one individual
                user but they may be reassigned from time to time to new users who are replacing former users who have
                terminated employment or otherwise changed job status or function and no longer use the Back Office
                System.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="1.4">
                You must not:
                <StListing type="a">
                    <StAlphabetListItem>
                        <StListText>
                            send spam or otherwise duplicative or unsolicited messages in violation of applicable laws;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            send or store infringing, obscene, threatening, libellous or otherwise unlawful or tortuous
                            material including material that is harmful to children or violates any rights of any third
                            party;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            send or store any material containing software viruses or harmful computer code, files,
                            scripts, agents or programs;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            interfere or disrupt the integrity or performance of the Back Office System or Service or
                            the data contained therein;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            attempt to gain unauthorised access to the Back Office System or Service or its related
                            systems or networks; or
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            after termination of this Agreement use, reproduce, retain, transfer, lend or sell any
                            Content originating or obtained from the Service.
                        </StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="1.5">
                You must not copy any Content including but not limited to text, audio or video from the Service onto
                hard drives, portable drives, CDs, DVDs or any recordable media including portable devices except as
                expressly permitted under this Agreement.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="1.6">
                <br />
                <StListing type="a">
                    <StAlphabetListItem>
                        <StListText>This Agreement is to operate for an initial term of 12 months.</StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            Either party may terminate this Agreement by giving the other party written notice no later
                            than 90 days before the end of a term.
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            If notice of termination is not given, the Agreement is deemed to be renewed for an
                            additional term of 12 months.
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            {' '}
                            Unless terminated in accordance with clause 1.6(b), this Agreement is to be renewed for
                            consecutive 12 month terms indefinitely.
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            In addition to the above, the Agreement may also be terminated in accordance with clause 12.
                        </StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="1.7">
                Content that may be added to the Service from time to time may carry certain usage conditions required
                by content providers, with which Bolinda Digital must comply as part of its agreements to bring the
                world’s best content to its customers. Such conditions may include limits on Content’s lifespan or a
                certain number of loans. Usage conditions will be detailed in applicable price lists.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>2. Your Responsibilities</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="2.1">
                You are responsible for all activity occurring under Back Office System user accounts operated by staff
                or volunteers. You must use your best efforts to ensure that you and such users abide by all applicable
                local, state and national laws and regulations in connection with your use of the Back Office System,
                including but not limited to those relating to privacy and the transmission of personal data.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="2.2">
                You must ensure that the information obtained from your Back Office System users is correct and
                accurate.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="2.3">
                You must provide Bolinda Digital with the details of any unauthorised use of any password or account or
                any other known or suspected breach of security.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="2.4">
                You must ensure that all End Users are properly authorised members of your library and are physically
                resident in your geographical area of operation.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>3. Privacy</StSubHeading>
        </p>
        <p className="P1">
            <span className="T2">
                Bolinda Digital's Privacy Policy can be located at the Service’s website. Bolinda Digital reserves the
                right to change its policies from time to time. When End Users first use the Service, they will be asked
                whether they wish to receive marketing material. End Users may opt out of receiving marketing material
                at any time by changing their preferences in their account settings. Bolinda Digital may occasionally
                need to notify all users of the Service (including those who opt out of receiving marketing material) of
                important announcements relating to the operation of the Service.{' '}
            </span>
        </p>
        <p className="P1">
            <StSubHeading>4. Intellectual Property</StSubHeading>
        </p>
        <p className="P1">
            <span className="T2">
                <TermsAndConditionsParagraph number="4.1">
                    Bolinda Digital and its content providers own all rights, title and interest, including without
                    limitation all intellectual property rights, in and to the Back Office System, the Service and the
                    Content, including but not limited to copyright, registered and unregistered trademarks, patents and
                    designs, know-how and other trade secrets, confidential information and similar forms of protection
                    anywhere in the world. No title of ownership, in any form whatsoever, to the Back Office System, the
                    Service or the Content is transferred by this Agreement. No right or licence is granted except as
                    expressly set out in this Agreement.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P1">
            <span className="T2">
                <TermsAndConditionsParagraph number="4.2">
                    Content that may be added to the Service from time to time may carry certain usage conditions
                    required by content providers, with which Bolinda Digital must comply as part of its agreements to
                    bring the world’s best content to its customers. Such conditions may limit the usage of Content to a
                    period of time or a certain number of loans (e.g. expiry after 2 years or 26 loans). Usage
                    conditions will be detailed in applicable price lists.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P1">
            <span className="T2">
                <TermsAndConditionsParagraph number="4.3">
                    Any suggestions, ideas, enhancement requests, improvements, feedback or recommendations provided by
                    you relating to the Back Office System and/or Service will be owned by Bolinda Digital.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P1">
            <span className="T2">
                <TermsAndConditionsParagraph number="4.4">
                    Any intellectual property which you provide to Bolinda Digital for use with the Back Office System
                    or the Service (including your logo) remains yours, and you grant Bolinda Digital a non-exclusive
                    licence to use such intellectual property only for the purposes of this Agreement. Bolinda Digital
                    will not be responsible for the accuracy, quality, integrity, legality, reliability and
                    appropriateness of the intellectual property you provide to us, nor will it be liable for the
                    deletion, correction, destruction, damage, loss or failure to store any such intellectual property.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P1">
            <span className="T2">
                <TermsAndConditionsParagraph number="4.5">
                    On termination of this Agreement your licence to use the intellectual property including the Back
                    Office System, Service and Content will cease and you must not make any further use of all or any
                    part of the Back Office System, Service or Content including but not limited to reproducing,
                    retaining, transferring, lending or selling any Content originating or obtained from the Service.{' '}
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P1">
            <StSubHeading>5. Enforcement of Intellectual Property</StSubHeading>
        </p>
        <p className="P1">
            <span className="T2">
                Under its agreements with content providers, Bolinda Digital is required to assist with the enforcement
                of intellectual property rights. You must:
                <StListing type="a">
                    <StAlphabetListItem>
                        <StListText>
                            assist in educating users on their responsibilities (including procuring staff and
                            volunteers to provide reasonable information to End Users, publishing Bolinda Digital
                            materials in print or electronically, or putting up educational posters); and
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            support enforcement actions carried out by Bolinda Digital, its agents or content providers.
                        </StListText>
                    </StAlphabetListItem>
                </StListing>
            </span>
        </p>
        <p className="P1">
            <StSubHeading>6. Infringement by End Users</StSubHeading>
        </p>
        <p className="P1">
            <span className="T2">
                <TermsAndConditionsParagraph number="6.1">
                    Content transacted through the Service includes active security technology (examples include digital
                    rights management, encryption and data centre security) that allows identification of files,
                    particularly whether files have been made available for sale or resale, or through file-sharing or
                    peer-to-peer networks. By agreeing to the EUTC, End Users consent to the identification of files.{' '}
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P1">
            <span className="T2">
                <TermsAndConditionsParagraph number="6.2">
                    If End Users infringe the EUTC, Bolinda Digital or content providers may:
                    <StListing type="a">
                        <StAlphabetListItem>
                            <StListText>
                                send warning emails or other notifications to the relevant End User/s;
                            </StListText>
                        </StAlphabetListItem>
                        <StAlphabetListItem>
                            <StListText>
                                suspend access by the relevant End User/s to the Service temporarily or permanently; and
                            </StListText>
                        </StAlphabetListItem>
                        <StAlphabetListItem>
                            <StListText>
                                issue legal proceedings for copyright infringement against the relevant End User/s.
                            </StListText>
                        </StAlphabetListItem>
                    </StListing>
                    If it is necessary to carry out stage (c), Bolinda will contact you to discuss how best to deal with
                    the infringements and your assistance will be required. This will only be done as a last resort.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P1">
            <span className="T2">
                <TermsAndConditionsParagraph number="6.3">
                    You must use your best endeavours to prevent such End Users from opening new accounts or using
                    different accounts to access the Service.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P1">
            <StSubHeading>7. Account Data and Information</StSubHeading>
        </p>
        <p className="P1">
            Any account data and information collected by Bolinda Digital will be used only for the purposes of
            providing the Service or promoting the Service. Bolinda Digital does not own any data or information that is
            obtained from you. You will have sole responsibility for the accuracy, quality, integrity, legality,
            reliability and appropriateness of user data.
        </p>
        <p className="P1">
            <StSubHeading>8. Fees and Charges</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="8.1">
                Fees and charges are as specified in the School Subscription Letter and in the School Price List.
                Because costs are impacted by third party content and service providers, these price lists and fees may
                change from time to time without notice.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="8.2">
                You must pay all fees or charges in accordance with the fees, charges and billing terms in effect at the
                time a fee or charge is due and payable. The payment term is specified on the invoice provided by
                Bolinda Digital.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="8.3">
                All payment obligations are non-cancellable and all amounts paid are non- refundable.
            </TermsAndConditionsParagraph>
        </p>

        <p className="P1">
            <TermsAndConditionsParagraph number="8.4">
                You must provide Bolinda Digital with valid banking details or approved purchase order information as a
                condition to entering into this Agreement.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="8.5">
                All pricing terms are confidential and you must not disclose them to any third party.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>9. Billing and Renewal</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="9.1">
                You agree to provide Bolinda Digital with complete and accurate billing and contact information. This
                information includes your legal entity name, street address, email address, and name and telephone
                number of an authorised billing contact and administrator. You must advise Bolinda Digital of any
                changes to these details within 30 days of changes being applied.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="9.2">
                If you believe that any billing information is incorrect, you must contact us in writing within 60 days
                of the invoice date containing the amount in question. Bolinda Digital will investigate the billing
                query and contact you about an adjustment or credit.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>10. Non-Payment and Suspension</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="10.1">
                Bolinda Digital reserves the right to suspend or terminate this Agreement and the Service if your
                account falls into arrears. Any account in arrears will be subject to the imposition of interest charges
                (calculated according to the rate specified by the Penalty Interest Rates Act (Vic) 1983) on any
                outstanding balance or the maximum permitted by law, whichever is less plus all expenses for collection
                of payment.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="10.2">
                Bolinda Digital may choose to charge a reconnection fee in the event that you are suspended and you
                request re-access to the Service. You agree that Bolinda Digital has no obligation to retain customer
                data and that such data may be deleted if your account is more than 30 days overdue.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>11. Termination</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="11.1">
                This Agreement will terminate immediately and without any notice if:
                <StListing type="a">
                    <StAlphabetListItem>
                        <StListText>
                            a receiver is appointed or you enter into liquidation or an order is made or resolution
                            passed for your winding-up;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            you make an assignment or transfer for the benefit of your creditors or in trust for your
                            creditors;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            you attempt to assign an interest in this Agreement, without the express written consent of
                            Bolinda Digital; or
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>you are unable to pay any liability when due and payable.</StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="11.2">
                Bolinda Digital may terminate this Agreement by giving you seven (7) days’ notice if:
                <StListing type="a">
                    <StAlphabetListItem>
                        <StListText>you are unwilling or unable to abide by these Terms and Conditions;</StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            you by way of act or omission, in Bolinda Digital's reasonable opinion, bring Bolinda
                            Digital's reputation into disrepute;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            an event described in clause 19.1 occurs and prior consent from Bolinda Digital is not
                            sought; or
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            you fail to remedy any other breach of this Agreement within 14 days of being notified by
                            Bolinda Digital of that breach.
                        </StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="11.3">
                Bolinda Digital may terminate this Agreement without cause, by giving you 30 days’ notice.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>12. Confidentiality</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="12.1">
                In this Agreement “Confidential Information” means any information (whether oral, in writing or
                otherwise) of or concerning Bolinda Digital and its commercial partners, including but not limited to
                any information which is potentially commercially valuable, any information regarding trade secrets,
                intellectual property (including know-how), software including any source code, discoveries, formulae,
                products, designs, drawings, artwork, processes, procedures or methods and information relating to
                business or financial affairs, transactions, Pricelists, accounts, projects, financing or management.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="12.2">
                You agree that you will:
                <StListing type="a">
                    <StAlphabetListItem>
                        <StListText>keep confidential;</StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>not disclose, reproduce or use; and</StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            not permit or allow the disclosure, reproduction or use by any staff and volunteers of, any
                            Confidential Information.
                        </StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="12.3">
                In particular, you must not:
                <StListing type="a">
                    <StAlphabetListItem>
                        <StListText>
                            disclose any aspect of this Agreement, price lists or other documentation related to the
                            Service or the Back Office System to a competitor of Bolinda Digital or Bolinda Publishing
                            Pty Ltd;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            allow any competitor of Bolinda Digital or Bolinda Publishing Pty Ltd access to the Service
                            or the Back Office System; or
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            provide any competitor of Bolinda Digital or Bolinda Publishing Pty Ltd with information
                            regarding the Service or the Back Office System.
                        </StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="12.4">
                If you become aware of any unauthorised disclosure or use of Confidential Information, you must
                immediately notify Bolinda Digital in writing of the full particulars of the disclosure or use.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="12.5">
                The confidentiality obligations contained in this Agreement will continue even after termination of this
                Agreement.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>13. Warranties</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="13.1">
                You warrant that you have legal power and authority to enter into this Agreement.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="13.2">
                You warrant that information you have provided is correct.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="13.3">
                You warrant that, when providing any material to us, you will use your best endeavours to ensure that
                you are not in breach of any third party rights and our use of such material will not constitute a
                breach.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="13.4">
                Bolinda Digital warrants that it will use its best endeavours to provide the Service in a manner that is
                consistent with industry standards under normal use and circumstance.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>14. Indemnity</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="14.1">
                Both parties will indemnify and hold each other and its licensors, parent company, subsidiary,
                affiliates, officers, directors, employees, attorneys and agents harmless from and against any claim,
                costs, damages, losses, liabilities and expenses including lawyer fees and costs, arising out of or in
                connection with any breach of this Agreement.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="14.2">
                In any such case, the party seeking to rely upon the indemnity must:
                <StListing>
                    <StAlphabetListItem>
                        <StListText>give the other party written notice of the claim, promptly;</StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            give the other party sole control of the defence and settlement of the claim (provided that
                            the other party may not settle or defend any claim unless it unconditionally releases the
                            first party of all liability and that settlement does not affect the first party’s business
                            or Service); and
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>provide the other party with all available information and assistance.</StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>15. Disclaimer</StSubHeading>
        </p>
        <p className="P1">
            Bolinda Digital provides a convenient, cutting-edge method for students, parents and staff to access the
            world’s best content via an effective conduit between schools and international publishers. Bolinda Digital
            cannot guarantee certain aspects of the Service’s performance because as a conduit, it does not control
            every facet of the pipeline.
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="15.1">
                Bolinda Digital and its licensors make no representation, warranties or guarantees as to the quality,
                reliability, sustainability, availability, truth, accuracy or completeness of the Service or Content.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="15.2">
                Bolinda Digital and its licensors do not represent or warrant that the use of the Service will be
                secure, timely, uninterrupted or error-free or operate in combination with any other hardware, software,
                system or data.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="15.3">
                Bolinda Digital, its licensors and service providers are not liable for any technical or other failures
                affecting any aspect of the Service.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="15.4">
                Bolinda Digital does not guarantee that the Service or Content will meet your requirements or
                expectations, nor that the quality of the Service or Content will meet your requirements or
                expectations.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="15.5">
                Bolinda Digital does not guarantee that the Service or the server(s) that make the Service available are
                free of viruses or other harmful components. The Service and all Content are provided to you on an "as
                is" basis.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="15.6">
                All conditions, representations and warranties, whether express or implied, including but not limited to
                any implied warranty of merchantable quality, fitness for purpose or non-infringement of third parties
                are disclaimed to the maximum extent permitted by applicable law.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="15.7">
                Bolinda Digital makes no warranty that use of the Service, the Back Office System or the Content will
                not infringe any intellectual property rights of any third party.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>16. Limitation of Liability</StSubHeading>
        </p>
        <p className="P1">
            In no event will the aggregate liability exceed the amounts actually paid by and/or due from you in the 12
            month period immediately preceding the event giving rise to such claim. In no event will Bolinda Digital and
            or its licensors be liable to anyone for any indirect, punitive, special, exemplary, incidental,
            consequential or other damages of any type or kind including loss of data, revenue, profits or other
            economic advantage, arising out of, or in any way connected with this Service, including but not limited to
            the use or inability to use the Service, or for any Content obtained from or through the Service, any
            interruption, inaccuracy, error or omission, regardless of cause, in the Content, even if the party from
            which damages are being sought or the party's licensors have been previously advised of the possibility of
            such damage.
        </p>
        <p className="P1">
            <StSubHeading>17. Notice</StSubHeading>
        </p>
        <p className="P1">
            Any notice required to be served on you will be addressed to your service administrator by electronic mail
            or by written communication posted to your address in accordance with Bolinda Digital's account information.
            Any notice by you to Bolinda Digital should be addressed by email to [jan@bolinda.com], or by post to our
            postal address [17 Mohr Street, Tullamarine, Victoria, 3043] addressed to [Mr Jan Herrmann - Director]. Any
            notice will be deemed to have been given upon the expiration of 48 hours after mailing or posting or after
            24 hours if sent by email.
        </p>
        <p className="P1">
            <StSubHeading>18. Modification of Agreement</StSubHeading>
        </p>
        <p className="P1">
            Bolinda Digital has the right to modify these Terms and Conditions or its policies relating to the Service
            or the Back Office System at any time, effective 14 days after posting of an updated version of these Terms
            and Conditions. You are responsible for regularly reviewing the Terms and Conditions. Continued use after
            the 14 day period following any such changes will constitute your consent to such changes.
        </p>
        <p className="P1">
            <StSubHeading>19. Assignment and Change of Ownership</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="19.1">
                This Agreement may not be assigned or transferred by you without prior written consent from Bolinda
                Digital. A transfer will be deemed to occur if there is a substantial change in your structure,
                ownership, management or area serviced, or if you merge with, acquire or are acquired by another
                library, even if the same entity is used. Under these circumstances, Bolinda Digital may terminate this
                Agreement according to the terms of clause 11.2 if its prior consent is not sought.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="19.2">
                This Agreement may be assigned without your consent by Bolinda Digital to a parent or subsidiary, an
                acquirer of assets or successor by merger.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>20. Internet Delays</StSubHeading>
        </p>
        <p className="P1">
            Bolinda Digital's services may be subject to limitation, delays and other problems inherent in the use of
            the Internet and electronic communications. Bolinda Digital is not responsible for any delays, delivery
            failures or other damage resulting from such problems.
        </p>
        <p className="P1">
            <StSubHeading>21. General</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="21.1">
                The laws of the Commonwealth of Australia and the State of Victoria govern this Agreement. You agree to
                submit to the exclusive jurisdiction of the courts of Victoria, Australia in any claim or dispute
                relating to or arising from this Agreement.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="21.2">
                If any provision of this Agreement is held by a court of competent jurisdiction to be invalid or
                unenforceable, all other provisions remain in full force and effect.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="21.3">
                This Agreement does not constitute a joint venture, partnership, employment or agency arrangement.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="21.4">
                These Terms and Conditions together with the School Subscription Letter comprise the entire Agreement
                between you and Bolinda Digital and supersede all prior or contemporaneous negotiations, discussions or
                agreements, whether written or oral, between the parties regarding the subject matter contained in this
                Agreement. If there is any inconsistency, the School Subscription Letter is to prevail over the Terms
                and Conditions.
            </TermsAndConditionsParagraph>
        </p>
    </StContentContainer>
);

export const TERMS_AND_CONDITIONS_ANZ_LIBRARY = (
    <StContentContainer>
        <StHeading>Library Terms and Conditions</StHeading>
        <p className="P2">
            <span className="T2">
                Welcome to BorrowBox, a Bolinda Digital service comprising the mobile services, apps, website and any
                software provided on or in connection with Bolinda Digital services (collectively the “Service”).
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                These Terms and Conditions must be read in conjunction with the Master Services Agreement (together
                “Agreement”). By signing the Master Services Agreement you agree to be bound by these Terms and
                Conditions.
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                Under this Agreement, Bolinda Digital Pty Ltd (“Bolinda Digital”) will:
                <br />
                <StListing leftOffset>
                    <StListItem>
                        provide your members (“End Users”) access to the Service under End User Terms and Conditions
                        (“EUTC”), which End Users must accept in order to borrow electronic media including but not
                        limited to audio books and ebooks (“Content”); and
                    </StListItem>
                    <StListItem>
                        provide you with a system (“Back Office System”) to manage the provision of the Service to your
                        End Users.
                    </StListItem>
                </StListing>
            </span>
        </p>
        <p className="P2">
            <StSubHeading>1. Usage of Back Office System </StSubHeading>
        </p>
        <p className="P2">
            <TermsAndConditionsParagraph number="1.1">
                Subject to the terms of this Agreement, Bolinda Digital grants you a non- exclusive, non-transferable
                licence to use the Back Office System, the Service, and the Content for the sole purpose of providing
                End Users with access to the Service so that they can borrow Content.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P2">
            <TermsAndConditionsParagraph number="1.2">
                You must not:
                <StListing type="a">
                    <StAlphabetListItem>
                        <StListText>
                            except as expressly permitted under this Agreement, license, sub-license, sell, transfer,
                            assign, distribute or otherwise commercially exploit or make available to any third party
                            the Back Office System, Service or Content in any way;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            modify or make derivative works based upon the Back Office System, Service or Content; or
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            reverse engineer or access the Back Office System or Service in order to build a competitive
                            product or service or a product with similar ideas, features, functions or graphics as the
                            Back Office System or Service.
                        </StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P2">
            <TermsAndConditionsParagraph number="1.3">
                You must not allow Back Office System user licences to be shared or used by more than one individual
                user but they may be reassigned from time to time to new users who are replacing former users who have
                terminated employment or otherwise changed job status or function and no longer use the Back Office
                System.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P2">
            <TermsAndConditionsParagraph number="1.4">
                You must not:
                <StListing>
                    <StAlphabetListItem>
                        <StListText>
                            send spam or otherwise duplicative or unsolicited messages in violation of applicable laws;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            send or store infringing, obscene, threatening, libellous or otherwise unlawful or tortuous
                            material including material that is harmful to children or violates any rights of any third
                            party;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            send or store any material containing software viruses or harmful computer code, files,
                            scripts, agents or programs;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            interfere or disrupt the integrity or performance of the Back Office System or Service or
                            the data contained therein;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            attempt to gain unauthorised access to the Back Office System or Service or its related
                            systems or networks; or
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            after termination of this Agreement use,reproduce, retain, transfer, lend or sell any
                            Content originating or obtained from the Service.
                        </StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P2">
            <TermsAndConditionsParagraph number="1.5">
                You must not copy any Content including but not limited to text, audio or video from the Service onto
                hard drives, portable drives, CDs, DVDs or any recordable media except as expressly permitted under this
                Agreement.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P2">
            <TermsAndConditionsParagraph number="1.6">
                <br />
                <StListing>
                    <StAlphabetListItem>
                        <StListText>This Agreement is to operate for an initial term of 3 years.</StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            Either party may terminate this Agreement by giving the other party written notice no later
                            than 90 days before the end of a term.
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            If notice of termination is not given, the Agreement is deemed to be renewed for an
                            additional term of 3 years.
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            Unless terminated in accordance with clause 1.6(b), this Agreement is to be renewed for
                            consecutive 3 year terms indefinitely.
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            In addition to the above, the Agreement may also be terminated in accordance with clause 11.
                        </StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P2">
            <StSubHeading>2. Your Responsibilities</StSubHeading>
        </p>
        <p className="P2">
            <TermsAndConditionsParagraph number="2.1">
                You are responsible for all activity occurring under Back Office System user accounts operated by staff
                or volunteers. You must ensure that you and such users abide by all applicable local, state and national
                laws and regulations in connection with your use of the Back Office System including but not limited to
                those relating to privacy and the transmission of personal data.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P2">
            <TermsAndConditionsParagraph number="2.2">
                You must ensure that the information obtained from your Back Office System users is correct and
                accurate.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P2">
            <TermsAndConditionsParagraph number="2.3">
                You must provide Bolinda Digital with the details of any unauthorised use of any password or account or
                any other known or suspected breach of security.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P2">
            <TermsAndConditionsParagraph number="2.4">
                You must ensure that all End Users are properly authorised members of your library and are physically
                resident in your geographical area of operation.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P2">
            <StSubHeading>3. Privacy</StSubHeading>
        </p>
        <p className="P2">
            Bolinda Digital's Privacy Policy can be located at the Service’s website. Bolinda Digital reserves the right
            to change its policies from time to time. When End Users first use the Service, they will be asked whether
            they wish to receive marketing material. End Users may opt out of receiving marketing material at any time
            by changing their preferences in their account settings. Bolinda Digital may occasionally need to notify all
            users of the Service (including those who opt out of receiving marketing material) of important
            announcements relating to the operation of the Service.
        </p>
        <p className="P2">
            <StSubHeading>4. Intellectual Property</StSubHeading>
        </p>
        <p className="P2">
            <TermsAndConditionsParagraph number="4.1">
                Bolinda Digital and its content providers own all rights, title and interest, including without
                limitation all intellectual property rights, in and to the Back Office System, the Service and/or the
                Content, including but not limited to copyright, registered and unregistered trademarks, patents and
                designs, know-how and other trade secrets, confidential information and similar forms of protection
                anywhere in the world. No title of ownership, in any form whatsoever, to the Back Office System, the
                Service or the Content is transferred by this Agreement. No right or licence is granted except as
                expressly set out in this Agreement.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="4.2">
                    Content that may be added to the Service from time to time may carry certain usage conditions
                    required by content providers, with which Bolinda Digital must comply as part of its agreements to
                    bring the world’s best content to its customers. Such conditions may limit the usage of Content to a
                    period of time or a certain number of loans (e.g. expiry after 2 years or 26 loans). Usage
                    conditions are detailed in applicable price lists.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="4.3">
                    Any suggestions, ideas, enhancement requests, improvements, feedback or recommendations provided by
                    you relating to the Back Office System and/or Service will be owned by Bolinda Digital.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="4.4">
                    Any intellectual property which you provide to Bolinda Digital for use with the Back Office System
                    or the Service (including your logo) remains yours, and you grant Bolinda Digital a non-exclusive
                    licence to use such intellectual property only for the purposes of this Agreement. Bolinda Digital
                    will not be responsible for the accuracy, quality, integrity, legality, reliability and
                    appropriateness of the Intellectual Property you provide to us, nor will it be liable for the
                    deletion, correction, destruction, damage, loss or failure to store any such intellectual property.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="4.5">
                    On termination of this Agreement your licence to use the intellectual property including the Back
                    Office System, Service and Content will cease and you must not make any further use of all or any
                    part of the Back Office System, Service or Content including but not limited to reproducing,
                    retaining, transferring, lending or selling any Content originating or obtained from the Service.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <StSubHeading>5. Enforcement of Intellectual Property </StSubHeading>
        </p>
        <p className="P2">
            <span className="T2">
                Under its agreements with content providers, Bolinda Digital is required to assist with the enforcement
                of intellectual property rights. You must:
                <StListing>
                    <StAlphabetListItem>
                        <StListText>
                            assist in educating users on their responsibilities (including procuring staff and
                            volunteers to provide reasonable information to End Users, publishing Bolinda Digital
                            materials in print or electronically, or putting up educational posters); and
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            support enforcement actions carried out by Bolinda Digital, its agents or content providers.{' '}
                        </StListText>
                    </StAlphabetListItem>
                </StListing>
            </span>
        </p>
        <p className="P2">
            <StSubHeading>6. Infringement by End Users </StSubHeading>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="6.1">
                    Content transacted through the Service includes active security technology (examples include digital
                    rights management, encryption and data centre security) that allows identification of files,
                    particularly whether files have been made available for sale or resale, or through file-sharing or
                    peer-to-peer networks. By agreeing to the EUTC End Users consent to the identification of files.{' '}
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="6.2">
                    If End Users infringe the EUTC, Bolinda Digital or content providers may:
                    <StListing>
                        <StAlphabetListItem>
                            <StListText>
                                send warning emails or other notifications to the relevant End User/s;
                            </StListText>
                        </StAlphabetListItem>
                        <StAlphabetListItem>
                            <StListText>
                                suspend access by the relevant End User/s to the Service temporarily or permanently; and
                            </StListText>
                        </StAlphabetListItem>
                        <StAlphabetListItem>
                            <StListText>
                                issue legal proceedings for copyright infringement against the relevant End User/s.
                                <br />
                                If it is necessary to carry out stage (c), Bolinda may request information on these End
                                Users, which must be provided within 7 days of receiving a written request. Information
                                requests will not exceed the terms of the Bolinda Privacy Policy as agreed by all End
                                Users.{' '}
                            </StListText>
                        </StAlphabetListItem>
                    </StListing>
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="6.3">
                    You must use your best endeavours to prevent such End Users from opening new accounts or using
                    different accounts to access the Service.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <StSubHeading>7. Account Data and Information </StSubHeading>
        </p>
        <p className="P2">
            <span className="T2">
                Any account data and information collected by Bolinda Digital will be used only for the purposes of
                providing the Service or promoting the Service. Bolinda Digital does not own any data or information
                that is obtained from you. You will have sole responsibility for the accuracy, quality, integrity,
                legality, reliability and appropriateness of user data.{' '}
            </span>
        </p>
        <p className="P2">
            <StSubHeading>8. Fees and Charges </StSubHeading>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="8.1">
                    Fees and charges are as specified in the Master Services Agreement and in the Solution and Services
                    Pricelist and the Content Pricelist. Because costs are impacted by third party content and service
                    providers, these price lists and fees are subject to change at any time without notice.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="8.2">
                    You must pay all fees or charges in accordance with the fees, charges and billing terms in effect at
                    the time a fee or charge is due and payable. The payment term is specified in the schedule to the
                    Master Services Agreement.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="8.3">
                    All payment obligations are non-cancellable and all amounts paid are non-refundable.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="8.4">
                    You must provide Bolinda Digital with valid banking details or approved purchase order information
                    as a condition to entering into this Agreement.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="8.5">
                    All pricing terms are confidential and you must not disclose them to any third party.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <StSubHeading>9. Billing and Renewal </StSubHeading>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="9.1">
                    You agree to provide Bolinda Digital with complete and accurate billing and contact information.
                    This information includes your legal entity name, street address, email address, and name and
                    telephone number of an authorised billing contact and administrator. You must advise Bolinda Digital
                    of any changes to these details within 30 days of changes being applied.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="9.2">
                    If you believe that any billing information is incorrect, you must contact us in writing within 60
                    days of the invoice date containing the amount in question. Bolinda Digital will investigate the
                    billing query and contact you about an adjustment or credit.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <StSubHeading>10. Non-Payment and Suspension </StSubHeading>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="10.1">
                    Bolinda Digital reserves the right to suspend or terminate this Agreement and the Service if your
                    account falls into arrears. Any account in arrears will be subject to the imposition of interest
                    charges (calculated according to the rate specified by the Penalty Interest Rates Act (Vic) 1983) on
                    any outstanding balance or the maximum permitted by law, whichever is less plus all expenses for
                    collection of payment.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="10.2">
                    Bolinda Digital may choose to charge a reconnection fee in the event that you are suspended and you
                    request re-access to the Service. You agree that Bolinda Digital has no obligation to retain
                    customer data and that such data may be deleted if your account is more than 30 days overdue.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <StSubHeading>11. Termination</StSubHeading>
        </p>
        <p className="P2">
            <TermsAndConditionsParagraph number="11.1">
                This Agreement will terminate immediately and without any notice if:
                <StListing type="a">
                    <StAlphabetListItem>
                        <StListText>
                            a receiver is appointed or you enter into liquidation or an order is made or resolution
                            passed for your winding-up;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            you make an assignment or transfer for the benefit of your creditors or in trust for your
                            creditors;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            you attempt to assign an interest in this Agreement, without the express written consent of
                            Bolinda Digital; or
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>you are unable to pay any liability when due and payable.</StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="11.2">
                    Bolinda Digital may terminate this Agreement by giving you seven (7) days’ notice if:
                    <StListing type="a">
                        <StAlphabetListItem>
                            <StListText>you are unwilling or unable to abide by these Terms and Conditions;</StListText>
                        </StAlphabetListItem>
                        <StAlphabetListItem>
                            <StListText>
                                you by way of act or omission, in Bolinda Digital's reasonable opinion, bring Bolinda
                                Digital's reputation into disrepute;
                            </StListText>
                        </StAlphabetListItem>
                        <StAlphabetListItem>
                            <StListText>
                                an event described in clause 19.1 occurs and prior consent from Bolinda Digital is not
                                sought; or
                            </StListText>
                        </StAlphabetListItem>
                        <StAlphabetListItem>
                            <StListText>
                                you fail to remedy any other breach of this Agreement within 14 days of being notified
                                by Bolinda Digital of that breach.
                            </StListText>
                        </StAlphabetListItem>
                    </StListing>
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="11.3">
                    Bolinda Digital may terminate this Agreement without cause, by giving you 30 days’ notice.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <StSubHeading>12. Confidentiality</StSubHeading>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="12.1">
                    In this agreement “Confidential Information” means any information (whether oral, in writing or
                    otherwise) of or concerning Bolinda Digital and its commercial partners, including but not limited
                    to any information which is potentially commercially valuable, any information regarding trade
                    secrets, intellectual property (including know-how), software including any source code,
                    discoveries, formulae, products, designs, drawings, artwork, processes, procedures or methods and
                    information relating to business or financial affairs, transactions, Pricelists, accounts, projects,
                    financing or management.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="12.2">
                    You agree that you will:
                    <StListing type="a">
                        <StAlphabetListItem>
                            <StListText>keep confidential;</StListText>
                        </StAlphabetListItem>
                        <StAlphabetListItem>
                            <StListText>not disclose, reproduce or use; and</StListText>
                        </StAlphabetListItem>
                        <StAlphabetListItem>
                            <StListText>
                                not permit or allow the disclosure, reproduction or use by any staff and volunteers of,
                                <br />
                                any Confidential Information.
                            </StListText>
                        </StAlphabetListItem>
                    </StListing>
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="12.3">
                    In particular, you must not:
                    <StListing type="a">
                        <StAlphabetListItem>
                            <StListText>
                                disclose any aspect of this Agreement, Pricelists or other documentation related to the
                                Service or the Back Office System to a competitor of Bolinda Digital or Bolinda
                                Publishing Pty Ltd;
                            </StListText>
                        </StAlphabetListItem>
                        <StAlphabetListItem>
                            <StListText>
                                allow any competitor of Bolinda Digital or Bolinda Publishing Pty Ltd access to the
                                Service or the Back Office System; or
                            </StListText>
                        </StAlphabetListItem>
                        <StAlphabetListItem>
                            <StListText>
                                provide any competitor of Bolinda Digital or Bolinda Publishing Pty Ltd with information
                                regarding the Service or the Back Office System.
                            </StListText>
                        </StAlphabetListItem>
                    </StListing>
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="12.4">
                    If you become aware of any unauthorised disclosure or use of the Confidential Information, you must
                    immediately notify Bolinda Digital in writing of the full particulars of the disclosure or use.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="12.5">
                    The confidentiality obligations contained in this Agreement will continue even after termination of
                    this Agreement.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <StSubHeading>13. Warranties</StSubHeading>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="13.1">
                    You warrant that you have legal power and authority to enter into this Agreement.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="13.2">
                    You warrant that information you have provided is correct.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="13.3">
                    You warrant that, when providing any material to us, you will use your best endeavours to ensure
                    that you are not in breach of any third party rights and our use of such material will not
                    constitute a breach.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="13.4">
                    Bolinda Digital warrants that it will use its best endeavours to provide the Service in a manner
                    that is consistent with industry standards under normal use and circumstance.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <StSubHeading>14. Indemnity</StSubHeading>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="14.1">
                    Both parties will indemnify and hold each other and its licensors, parent company, subsidiary,
                    affiliates, officers, directors, employees, attorneys and agents harmless from and against any
                    claim, costs, damages, losses, liabilities and expenses including lawyer fees and costs, arising out
                    of or in connection with any breach of this Agreement.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="14.2">
                    In any such case, the party seeking to rely upon the indemnity must:
                    <StListing type="a">
                        <StAlphabetListItem>
                            <StListText>give the other party written notice of the claim, promptly;</StListText>
                        </StAlphabetListItem>
                        <StAlphabetListItem>
                            <StListText>
                                give the other party sole control of the defence and settlement of the claim (provided
                                that the other party may not settle or defend any claim unless it unconditionally
                                releases the first party of all liability and that settlement does not affect the first
                                party’s business or Service); and
                            </StListText>
                        </StAlphabetListItem>
                        <StAlphabetListItem>
                            <StListText>
                                provide the other party with all available information and assistance.
                            </StListText>
                        </StAlphabetListItem>
                    </StListing>
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <StSubHeading>15. Disclaimer</StSubHeading>
        </p>
        <p className="P2">
            <span className="T2">
                Bolinda Digital provides a convenient, cutting-edge method for End Users to access the world’s best
                content via an effective conduit between libraries and international publishers. Bolinda Digital cannot
                guarantee certain aspects of the Service’s performance because as a conduit, it does not control every
                facet of the pipeline.
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="15.1">
                    Bolinda Digital and its licensors make no representation, warranties or guarantees as to the
                    quality, reliability, sustainability, availability, truth, accuracy or completeness of the Service
                    or Content.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="15.2">
                    Bolinda Digital and its licensors do not represent or warrant that the use of the Service will be
                    secure, timely, uninterrupted or error-free or operate in combination with any other hardware,
                    software, system or data.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="15.3">
                    Bolinda Digital, its licensors and service providers are not liable for any technical or other
                    failures affecting any aspect of the Service.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="15.4">
                    Bolinda Digital does not guarantee that the Service or Content will meet your requirements or
                    expectations, nor that the quality of the Service or Content will meet your requirements or
                    expectations.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="15.5">
                    Bolinda Digital does not guarantee that the Service or the server(s) that make the Service available
                    are free of viruses or other harmful components. The Service and all Content are provided to you on
                    an "as is" basis.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="15.6">
                    All conditions, representations and warranties, whether express or implied, including but not
                    limited to any implied warranty of merchantable quality, fitness for purpose or non-infringement of
                    third parties are disclaimed to the maximum extent permitted by applicable law.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="15.7">
                    Bolinda Digital makes no warranty that use of the Service, the Back Office System or the Content
                    will not infringe any intellectual property rights of any third party.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <StSubHeading>16. Limitation of Liability</StSubHeading>
        </p>
        <p className="P2">
            <span className="T2">
                In no event will the aggregate liability exceed the amounts actually paid by and/or due from you in the
                12 month period immediately preceding the event giving rise to such claim. In no event will Bolinda
                Digital and or its licensors be liable to anyone for any indirect, punitive, special, exemplary,
                incidental, consequential or other damages of any type or kind including loss of data, revenue, profits
                or other economic advantage, arising out of, or in any way connected with this Service, including but
                not limited to the use or inability to use the Service, or for any Content obtained from or through the
                Service, any interruption, inaccuracy, error or omission, regardless of cause, in the Content, even if
                the party from which damages are being sought or the party's licensors have been previously advised of
                the possibility of such damage.
            </span>
        </p>
        <p className="P2">
            <StSubHeading>17. Notice</StSubHeading>
        </p>
        <p className="P2">
            <span className="T2">
                Any notice required to be served on you will be addressed to your service administrator by electronic
                mail or by written communication posted to your address in accordance with Bolinda Digital's account
                information. Any notice by you to Bolinda Digital should be addressed by email to [jan@bolinda.com], or
                by post to our postal address [17 Mohr Street, Tullamarine, Victoria, 3043] addressed to [Mr Jan
                Herrmann - Director].{' '}
            </span>
            <span className="T2">
                Notice will be deemed to have been given upon the expiration of 48 hours after mailing or posting or
                after 24 hours if sent by email.
            </span>
        </p>
        <p className="P2">
            <StSubHeading>18. Modification of Agreement</StSubHeading>
        </p>
        <p className="P2">
            <span className="T2">
                Bolinda Digital has the right to modify these Terms and Conditions or its policies relating to the
                Service or the Back Office System at any time, effective upon posting of an updated version of these
                Terms and Conditions. You are responsible for regularly reviewing the Terms and Conditions. Continued
                use after any such changes will constitute your consent to such changes.
            </span>
        </p>
        <p className="P2">
            <StSubHeading>19. Assignment and Change of Ownership</StSubHeading>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="19.1">
                    This Agreement may not be assigned or transferred by you without prior written consent from Bolinda
                    Digital. A transfer will be deemed to occur if there is a substantial change in your structure,
                    ownership, management or area serviced, or you merge with, acquire or are acquired by another
                    library, even if the same entity is used. Under these circumstances, Bolinda Digital may terminate
                    this Agreement according to the terms of clause 11.1 if its prior consent is not sought.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="19.2">
                    This Agreement may be assigned without your consent by Bolinda Digital to a parent or subsidiary, an
                    acquirer of assets or successor by merger.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <StSubHeading>20. Internet Delays</StSubHeading>
        </p>
        <p className="P2">
            <span className="T2">
                Bolinda Digital's services may be subject to limitation, delays and other problems inherent in the use
                of the Internet and electronic communications. Bolinda Digital is not responsible for any delays,
                delivery failures or other damage resulting from such problems.
            </span>
        </p>
        <p className="P2">
            <StSubHeading>21. General</StSubHeading>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="21.1">
                    The laws of the Commonwealth of Australia and the State of Victoria govern this Agreement. You agree
                    to submit to the exclusive jurisdiction of the courts of Victoria, Australia in any claim or dispute
                    relating to or arising from this Agreement.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="21.2">
                    If any provision of this Agreement is held by a court of competent jurisdiction to be invalid or
                    unenforceable provision(s), all other provisions remain in full force and effect.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="21.3">
                    This Agreement does not constitute a joint venture, partnership, employment or agency arrangement.
                </TermsAndConditionsParagraph>
            </span>
        </p>
        <p className="P2">
            <span className="T2">
                <TermsAndConditionsParagraph number="21.4">
                    These Terms and Conditions together with the Master Services Agreement comprise the entire Agreement
                    between you and Bolinda Digital and supersede all prior or contemporaneous negotiations, discussions
                    or agreements, whether written or oral, between the parties regarding the subject matter contained
                    in this Agreement. If there is any inconsistency, the Master Services Agreement is to prevail over
                    the Terms and Conditions.
                </TermsAndConditionsParagraph>
            </span>
        </p>
    </StContentContainer>
);

export const TERMS_AND_CONDITIONS_UK = (
    <StContentContainer>
        <StHeading>Library Terms and Conditions</StHeading>
        <p className="P1">
            Welcome to BorrowBox, a Bolinda Digital service comprising the mobile services, apps, website and any
            software provided on or in connection with Bolinda Digital services (collectively the “Service”).
        </p>
        <p className="P1">
            These Terms and Conditions must be read in conjunction with the Master Services Agreement (together
            “Agreement”). By signing the Master Services Agreement you agree to be bound by these Terms and Conditions.
        </p>
        <p className="P1">
            Under this Agreement, Bolinda Digital Pty Ltd (“Bolinda Digital”) will:
            <StListing leftOffset>
                <StListItem>
                    provide your members (“End Users”) access to the Service under End User Terms and Conditions
                    (“EUTC”), which End Users must accept in order to borrow electronic media including but not limited
                    to audio books and ebooks (“Content”); and
                </StListItem>
                <StListItem>
                    provide you with a system (“Master Service System”) to manage the provision of the Service to your
                    End Users.
                </StListItem>
            </StListing>
        </p>
        <p className="P1">
            <StSubHeading>1. Usage of Master Service System</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="1.1">
                Subject to the terms of this Agreement, Bolinda Digital grants you a non- exclusive, non-transferable
                licence to use the Master Service System, the Service, and the Content for the sole purpose of providing
                End Users with access to the Service so that they can borrow Content.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="1.2">
                You must not:
                <StListing type="a">
                    <StAlphabetListItem>
                        <StListText>
                            except as expressly permitted under this Agreement, license, sub-license, sell, transfer,
                            assign, distribute or otherwise commercially exploit or make available to any third party
                            the Master Service System, Service or Content in any way;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            modify or make derivative works based upon the Master Service System, Service or Content; or
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            reverse engineer or access the Master Service System or Service in order to build a
                            competitive product or service or a product with similar ideas, features, functions or
                            graphics as the Master Service System or Service.
                        </StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="1.3">
                You must not allow Master Service System user licences to be shared or used by more than one individual
                user but they may be reassigned from time to time to new users who are replacing former users who have
                terminated employment or otherwise changed job status or function and no longer use the Master Service
                System.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="1.4">
                You must not:
                <br />
                <StListing>
                    <StAlphabetListItem>
                        <StListText>
                            send spam or otherwise duplicative or unsolicited messages in violation of applicable laws;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            send or store infringing, obscene, threatening, libellous or otherwise unlawful or tortuous
                            material including material that is harmful to children or violates any rights of any third
                            party;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            send or store any material containing software viruses or harmful computer code, files,
                            scripts, agents or programs;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            interfere or disrupt the integrity or performance of the Master Service System or Service or
                            the data contained therein;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            attempt to gain unauthorised access to the Master Service System or Service or its related
                            systems or networks; or
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            after termination of this Agreement use, reproduce, retain, transfer, lend or sell any
                            Content originating or obtained from the Service.
                        </StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="1.5">
                You must not copy any Content including but not limited to text, audio or video from the Service onto
                hard drives, portable drives, CDs, DVDs or any recordable media except as expressly permitted under this
                Agreement.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="1.6">
                <br />
                <StListing>
                    <StAlphabetListItem>
                        <StListText>This Agreement is to operate for an initial term of 3 years.</StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            Either party may terminate this Agreement by giving the other party written notice no later
                            than 90 days before the end of a term.
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            If notice of termination is not given, the Agreement is deemed to be renewed for an
                            additional term of 3 years.
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            Unless terminated in accordance with clause 1.6(b), this Agreement is to be renewed for
                            consecutive 3 year terms indefinitely.
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            In addition to the above, the Agreement may also be terminated in accordance with clause 11.
                        </StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>2. Your Responsibilities</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="2.1">
                You are responsible for all activity occurring under Master Service System user accounts operated by
                staff or volunteers. You must ensure that you and such users abide by all applicable local, state and
                national laws and regulations in connection with your use of the Master Service System including but not
                limited to those relating to privacy and the transmission of personal data.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="2.2">
                You must ensure that the information obtained from your Master Service System users is correct and
                accurate.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="2.3">
                You must provide Bolinda Digital with the details of any unauthorised use of any password or account or
                any other known or suspected breach of security.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="2.4">
                You must ensure that all End Users are properly authorised members of your library and are physically
                resident in your geographical area of operation.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>3. Privacy</StSubHeading>
        </p>
        <p className="P1">
            Bolinda Digital's Privacy Policy can be located at the Service’s website. Bolinda Digital reserves the right
            to change its policies from time to time. When End Users first use the Service, they will be asked whether
            they wish to receive marketing material. End Users may opt out of receiving marketing material at any time
            by changing their preferences in their account settings. Bolinda Digital may occasionally need to notify all
            users of the Service (including those who opt out of receiving marketing material) of important
            announcements relating to the operation of the Service.
        </p>
        <p className="P1">
            <StSubHeading>4. Intellectual Property</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="4.1">
                Bolinda Digital and its content providers own all rights, title and interest, including without
                limitation all intellectual property rights, in and to the Master Service System, the Service and/or the
                Content, including but not limited to copyright, registered and unregistered trademarks, patents and
                designs, know-how and other trade secrets, confidential information and similar forms of protection
                anywhere in the world. No title of ownership, in any form whatsoever, to the Master Service System, the
                Service or the Content is transferred by this Agreement. No right or licence is granted except as
                expressly set out in this Agreement.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="4.2">
                Content that may be added to the Service from time to time may carry certain usage conditions required
                by content providers, with which Bolinda Digital must comply as part of its agreements to bring the
                world’s best content to its customers. Such conditions may limit the usage of Content to a period of
                time or a certain number of loans (e.g. expiry after 2 years or 26 loans). Usage conditions are detailed
                in applicable price lists and are subject to change at any time.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="4.3">
                Any suggestions, ideas, enhancement requests, improvements, feedback or recommendations provided by you
                relating to the Master Service System and/or Service will be owned by Bolinda Digital.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="4.4">
                Any intellectual property which you provide to Bolinda Digital for use with the Master Service System or
                the Service (including your logo) remains yours, and you grant Bolinda Digital a non-exclusive licence
                to use such intellectual property only for the purposes of this Agreement. Bolinda Digital will not be
                responsible for the accuracy, quality, integrity, legality, reliability and appropriateness of the
                Intellectual Property you provide to us, nor will it be liable for the deletion, correction,
                destruction, damage, loss or failure to store any such intellectual property.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="4.5">
                On termination of this Agreement your licence to use the intellectual property including the Master
                Service System, Service and Content will cease and you must not make any further use of all or any part
                of the Master Service System, Service or Content including but not limited to reproducing, retaining,
                transferring, lending or selling any Content originating or obtained from the Service.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>5. Enforcement of Intellectual Property</StSubHeading>
        </p>
        <p className="P1">
            Under its agreements with content providers, Bolinda Digital is required to assist with the enforcement of
            intellectual property rights. You must:
            <StListing>
                <StAlphabetListItem>
                    <StListText>
                        assist in educating users on their responsibilities (including procuring staff and volunteers to
                        provide reasonable information to End Users, publishing Bolinda Digital materials in print or
                        electronically, or putting up educational posters); and
                    </StListText>
                </StAlphabetListItem>
                <StAlphabetListItem>
                    <StListText>
                        support enforcement actions carried out by Bolinda Digital, its agents or content providers.
                    </StListText>
                </StAlphabetListItem>
            </StListing>
        </p>
        <p className="P1">
            <StSubHeading>6. Infringement by End Users</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="6.1">
                Content transacted through the Service includes active security technology (examples include digital
                rights management, encryption and data centre security) that allows identification of files,
                particularly whether files have been made available for sale or resale, or through file-sharing or
                peer-to-peer networks. By agreeing to the EUTC End Users consent to the identification of files.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="6.2">
                If End Users infringe the EUTC, Bolinda Digital or content providers may:
                <StListing>
                    <StAlphabetListItem>
                        <StListText>send warning emails or other notifications to the relevant End User/s;</StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            suspend access by the relevant End User/s to the Service temporarily or permanently; and
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            issue legal proceedings for copyright infringement against the relevant End User/s.
                            <br />
                            If it is necessary to carry out stage (c), Bolinda may request information on these End
                            Users, which must be provided within 7 days of receiving a written request. Information
                            requests will not exceed the terms of the Bolinda Privacy Policy as agreed by all End Users.
                        </StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="6.3">
                You must use your best endeavours to prevent such End Users from opening new accounts or using different
                accounts to access the Service.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>7. Preloaded audio equipment loans</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="7.1">
                You are permitted to offer library members a service incorporating the loan of audio equipment preloaded
                with Content requested by a particular borrower. Special logins will be provided exclusively for this
                purpose.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="7.2">
                In all cases you must comply with the EUTC and ensure that all borrowers receive enough information to
                allow them to comply with the End User Licence Agreement. In particular, you must ensure that all
                Content files on audio equipment is erased in between loans, and in any case within 5 business days of
                equipment being returned.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="7.3">
                You must keep records of all borrowers, including names, addresses, phone numbers, emails, borrowing
                dates and uploaded Content. Records must be kept for a minimum of 2 years.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="7.4">
                For the purposes of monitoring compliance with security and copyright, you must provide Bolinda Digital
                with details of all such devices and all information on loans (within specific periods as specified by
                Bolinda Digital), the identities of borrowers and all information available on each borrower within 7
                days of receiving a written request.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="7.5">
                Bolinda Digital may carry out audits of your recordkeeping and systems upon giving notice of a minimum
                of 3 business days
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>8. Account Data and Information</StSubHeading>
        </p>
        <p className="P1">
            Any account data and information collected by Bolinda Digital will be used only for the purposes of
            providing the Service or promoting the Service. Bolinda Digital does not own any data or information that is
            obtained from you. You will have sole responsibility for the accuracy, quality, integrity, legality,
            reliability and appropriateness of user data.
        </p>
        <p className="P1">
            <StSubHeading>9. Fees and Charges</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="9.1">
                Fees and charges are as specified in the Master Services Agreement and in the Solution and Services
                Pricelist and the Content Pricelist. Because costs are impacted by third party content and service
                providers, these price lists and fees are subject to change at any time without notice.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="9.2">
                You must pay all fees or charges in accordance with the fees, charges and billing terms in effect at the
                time a fee or charge is due and payable. The payment term is specified in the schedule to the Master
                Services Agreement.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="9.3">
                All payment obligations are non-cancellable and all amounts paid are non- refundable.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="9.4">
                You must provide Bolinda Digital with valid banking details or approved purchase order information as a
                condition to entering into this Agreement.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="9.5">
                All pricing terms are confidential and you must not disclose them to any third party.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>10. Billing and Renewal</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="10.1">
                You agree to provide Bolinda Digital with complete and accurate billing and contact information. This
                information includes your legal entity name, street address, email address, and name and telephone
                number of an authorised billing contact and administrator. You must advise Bolinda Digital of any
                changes to these details within 30 days of changes being applied.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="10.2">
                If you believe that any billing information is incorrect, you must contact us in writing within 60 days
                of the invoice date containing the amount in question. Bolinda Digital will investigate the billing
                query and contact you about an adjustment or credit.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>11. Non-Payment and Suspension</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="11.1">
                Bolinda Digital reserves the right to suspend or terminate this Agreement and the Service if your
                account falls into arrears. Any account in arrears will be subject to the imposition of interest charges
                (calculated according to the rate specified by the Penalty Interest Rates Act (Vic) 1983) on any
                outstanding balance or the maximum permitted by law, whichever is less plus all expenses for collection
                of payment.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="11.2">
                Bolinda Digital may choose to charge a reconnection fee in the event that you are suspended and you
                request re-access to the Service. You agree that Bolinda Digital has no obligation to retain customer
                data and that such data may be deleted if your account is more than 30 days overdue.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>12. Termination</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="12.1">
                This Agreement will terminate immediately and without any notice if:
                <StListing>
                    <StAlphabetListItem>
                        <StListText>
                            a receiver is appointed or you enter into liquidation or an order is made or resolution
                            passed for your winding-up;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            you make an assignment or transfer for the benefit of your creditors or in trust for your
                            creditors;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            you attempt to assign an interest in this Agreement, without the express written consent of
                            Bolinda Digital; or
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>you are unable to pay any liability when due and payable.</StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="12.2">
                Bolinda Digital may terminate this Agreement by giving you seven (7) days’ notice if:
                <StListing>
                    <StAlphabetListItem>
                        <StListText>you are unwilling or unable to abide by these Terms and Conditions;</StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            you by way of act or omission, in Bolinda Digital's reasonable opinion, bring Bolinda
                            Digital's reputation into disrepute;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            an event described in clause 19.1 occurs and prior consent from Bolinda Digital is not
                            sought; or
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            you fail to remedy any other breach of this Agreement within 14 days of being notified by
                            Bolinda Digital of that breach.
                        </StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="12.3">
                Bolinda Digital may terminate this Agreement without cause, by giving you 30 days’ notice.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>13. Confidentiality</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="13.1">
                In this agreement “Confidential Information” means any information (whether oral, in writing or
                otherwise) of or concerning Bolinda Digital and its commercial partners, including but not limited to
                any information which is potentially commercially valuable, any information regarding trade secrets,
                intellectual property (including know-how), software including any source code, discoveries, formulae,
                products, designs, drawings, artwork, processes, procedures or methods and information relating to
                business or financial affairs, transactions, Pricelists, accounts, projects, financing or management.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="13.2">
                You agree that you will:
                <StListing>
                    <StAlphabetListItem>
                        <StListText>keep confidential;</StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>not disclose, reproduce or use; and</StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            not permit or allow the disclosure, reproduction or use by any staff and volunteers of, any
                            Confidential Information.
                        </StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="13.3">
                In particular, you must not:
                <StListing>
                    <StAlphabetListItem>
                        <StListText>
                            disclose any aspect of this Agreement, Pricelists or other documentation related to the
                            Service or the Master Service System to a competitor of Bolinda Digital or Bolinda
                            Publishing Pty Ltd;
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            allow any competitor of Bolinda Digital or Bolinda Publishing Pty Ltd access to the Service
                            or the Master Service System; or
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            provide any competitor of Bolinda Digital or Bolinda Publishing Pty Ltd with information
                            regarding the Service or the Master Service System.
                        </StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="13.4">
                If you become aware of any unauthorised disclosure or use of the Confidential Information, you must
                immediately notify Bolinda Digital in writing of the full particulars of the disclosure or use.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="13.5">
                The confidentiality obligations contained in this Agreement will continue even after termination of this
                Agreement.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>14. Warranties</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="14.1">
                You warrant that you have legal power and authority to enter into this Agreement.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="14.2">
                You warrant that information you have provided is correct.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="14.3">
                You warrant that, when providing any material to us, you will use your best endeavours to ensure that
                you are not in breach of any third party rights and our use of such material will not constitute a
                breach.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="14.4">
                Bolinda Digital warrants that it will use its best endeavours to provide the Service in a manner that is
                consistent with industry standards under normal use and circumstance.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>15. Indemnity</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="15.1">
                Both parties will indemnify and hold each other and its licensors, parent company, subsidiary,
                affiliates, officers, directors, employees, attorneys and agents harmless from and against any claim,
                costs, damages, losses, liabilities and expenses including lawyer fees and costs, arising out of or in
                connection with any breach of this Agreement.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="15.2">
                In any such case, the party seeking to rely upon the indemnity must:
                <StListing>
                    <StAlphabetListItem>
                        <StListText>give the other party written notice of the claim, promptly;</StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>
                            give the other party sole control of the defence and settlement of the claim (provided that
                            the other party may not settle or defend any claim unless it unconditionally releases the
                            first party of all liability and that settlement does not affect the first party’s business
                            or Service); and
                        </StListText>
                    </StAlphabetListItem>
                    <StAlphabetListItem>
                        <StListText>provide the other party with all available information and assistance.</StListText>
                    </StAlphabetListItem>
                </StListing>
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>16. Disclaimer</StSubHeading>
        </p>
        <p className="P1">
            Bolinda Digital provides a convenient, cutting-edge method for End Users to access the world’s best content
            via an effective conduit between libraries and international publishers. Bolinda Digital cannot guarantee
            certain aspects of the Service’s performance because as a conduit, it does not control every facet of the
            pipeline.
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="16.1">
                Bolinda Digital and its licensors make no representation, warranties or guarantees as to the quality,
                reliability, sustainability, availability, truth, accuracy or completeness of the Service or Content.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="16.2">
                Bolinda Digital and its licensors do not represent or warrant that the use of the Service will be
                secure, timely, uninterrupted or error-free or operate in combination with any other hardware, software,
                system or data.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="16.3">
                Bolinda Digital, its licensors and service providers are not liable for any technical or other failures
                affecting any aspect of the Service.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="16.4">
                Bolinda Digital does not guarantee that the Service or Content will meet your requirements or
                expectations, nor that the quality of the Service or Content will meet your requirements or
                expectations.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="16.5">
                Bolinda Digital does not guarantee that the Service or the server(s) that make the Service available are
                free of viruses or other harmful components. The Service and all Content are provided to you on an "as
                is" basis.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="16.6">
                All conditions, representations and warranties, whether express or implied, including but not limited to
                any implied warranty of merchantable quality, fitness for purpose or non-infringement of third parties
                are disclaimed to the maximum extent permitted by applicable law.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="16.7">
                Bolinda Digital makes no warranty that use of the Service, the Master Service System or the Content will
                not infringe any intellectual property rights of any third party.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>17. Limitation of Liability</StSubHeading>
        </p>
        <p className="P1">
            In no event will the aggregate liability exceed the amounts actually paid by and/or due from you in the 12
            month period immediately preceding the event giving rise to such claim. In no event will Bolinda Digital and
            or its licensors be liable to anyone for any indirect, punitive, special, exemplary, incidental,
            consequential or other damages of any type or kind including loss of data, revenue, profits or other
            economic advantage, arising out of, or in any way connected with this Service, including but not limited to
            the use or inability to use the Service, or for any Content obtained from or through the Service, any
            interruption, inaccuracy, error or omission, regardless of cause, in the Content, even if the party from
            which damages are being sought or the party's licensors have been previously advised of the possibility of
            such damage.
        </p>
        <p className="P1">
            <StSubHeading>18. Notice</StSubHeading>
        </p>
        <p className="P1">
            Any notice required to be served on you will be addressed to your service administrator by electronic mail
            or by written communication posted to your address in accordance with Bolinda Digital's account information.
            Any notice by you to Bolinda Digital should be addressed by email to [jan@bolinda.com], or by post to our
            postal address [17 Mohr Street, Tullamarine, Victoria, 3043] addressed to [Mr Jan Herrmann - Director].
            Notice will be deemed to have been given upon the expiration of 48 hours after mailing or posting or after
            24 hours if sent by email.
        </p>
        <p className="P1">
            <StSubHeading>19. Modification of Agreement</StSubHeading>
        </p>
        <p className="P1">
            Bolinda Digital has the right to modify these Terms and Conditions or its policies relating to the Service
            or the Master Service System at any time, effective upon posting of an updated version of these Terms and
            Conditions. You are responsible for regularly reviewing the Terms and Conditions. Continued use after any
            such changes will constitute your consent to such changes.
        </p>
        <p className="P1">
            <StSubHeading>20. Assignment and Change of Ownership</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="20.1">
                This Agreement may not be assigned or transferred by you without prior written consent from Bolinda
                Digital. A transfer will be deemed to occur if there is a substantial change in your structure,
                ownership, management or area serviced, or you merge with, acquire or are acquired by another library,
                even if the same entity is used. Under these circumstances, Bolinda Digital may terminate this Agreement
                according to the terms of clause 11.1 if its prior consent is not sought.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="20.2">
                This Agreement may be assigned without your consent by Bolinda Digital to a parent or subsidiary, an
                acquirer of assets or successor by merger.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <StSubHeading>21. Internet Delays</StSubHeading>
        </p>
        <p className="P1">
            Bolinda Digital's services may be subject to limitation, delays and other problems inherent in the use of
            the Internet and electronic communications. Bolinda Digital is not responsible for any delays, delivery
            failures or other damage resulting from such problems.
        </p>
        <p className="P1">
            <StSubHeading>22. General</StSubHeading>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="22.1">
                The laws of the Commonwealth of Australia and the State of Victoria govern this Agreement. You agree to
                submit to the exclusive jurisdiction of the courts of Victoria, Australia in any claim or dispute
                relating to or arising from this Agreement.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="22.2">
                If any provision of this Agreement is held by a court of competent jurisdiction to be invalid or
                unenforceable provision(s), all other provisions remain in full force and effect.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="22.3">
                This Agreement does not constitute a joint venture, partnership, employment or agency arrangement.
            </TermsAndConditionsParagraph>
        </p>
        <p className="P1">
            <TermsAndConditionsParagraph number="22.4">
                These Terms and Conditions together with the Master Services Agreement comprise the entire Agreement
                between you and Bolinda Digital and supersede all prior or contemporaneous negotiations, discussions or
                agreements, whether written or oral, between the parties regarding the subject matter contained in this
                Agreement. If there is any inconsistency, the Master Services Agreement is to prevail over the Terms and
                Conditions.
            </TermsAndConditionsParagraph>
        </p>
    </StContentContainer>
);
